import http from "./http-common";
import authHeader from "./auth-header";
import process from "shelljs";

const API_URL = process.env.BFF_URL;

class CommunicationService {

  create(mid, communication) {
    return http.post(API_URL + `/v1/merchants/${mid}/messages`, communication, {headers: authHeader()});
  }

  update(mid, id, communication) {
    return http.put(API_URL + `/v1/merchants/${mid}/messages/${id}`, communication, {headers: authHeader()});
  }

  findById(mid, id) {
    return http.get(API_URL + `/v1/merchants/${mid}/messages/${id}`, {headers: authHeader()});
  }

  delete(mid, id) {
    return http.delete(API_URL + `/v1/merchants/${mid}/messages/${id}`, {headers: authHeader()});
  }

  find(mid, params) {
    return http.get(API_URL + `/v1/merchants/${mid}/messages`, {params: params, headers: authHeader()})
  }
}

export default new CommunicationService();



// WEBPACK FOOTER //
// ./src/service/communication.service.js